export const contactApi = {
  async submitMessage(data) {
    const endpoints = ['/api/messageTable/insert', '/messageTable/insert'];
    const body = JSON.stringify(data);

    const postJson = async (url) => {
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body,
      });

      const contentType =
        res.headers && res.headers.get
          ? res.headers.get('content-type') || ''
          : '';

      if (contentType.includes('application/json')) {
        const result = await res.json();
        if (res.ok) return result;
        const message =
          (result && (result.message || result.msg)) || 'Request failed';
        const err = new Error(message);
        err.status = res.status;
        err.data = result;
        throw err;
      }

      if (res.ok) return { ok: true, status: res.status };

      const err = new Error('Request failed');
      err.status = res.status;
      throw err;
    };

    try {
      const result = await postJson(endpoints[0]);
      if (result && typeof result.code !== 'undefined' && result.code !== 200) {
        throw new Error(result.message || result.msg || 'Request failed');
      }
      return result;
    } catch (e) {
      const status = e && typeof e.status === 'number' ? e.status : 0;
      if (status && status !== 404) throw e;
      if (!endpoints[1]) throw e;
      const result = await postJson(endpoints[1]);
      if (result && typeof result.code !== 'undefined' && result.code !== 200) {
        throw new Error(result.message || result.msg || 'Request failed');
      }
      return result;
    }
  },
};

export const emailSubmitApi = {
  async submitEmail(email) {
    const endpoints = [
      '/api/emailSubmit/submit',
      '/emailSubmit/submit',
      '/api/emailPush/add',
      '/emailPush/add',
    ];

    const postJson = async (url) => {
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const contentType =
        res.headers && res.headers.get
          ? res.headers.get('content-type') || ''
          : '';

      if (contentType.includes('application/json')) {
        const result = await res.json();
        if (res.ok) return result;
        const message =
          (result && (result.message || result.msg)) || 'Request failed';
        const err = new Error(message);
        err.status = res.status;
        err.data = result;
        throw err;
      }

      if (res.ok) return { ok: true, status: res.status };

      const err = new Error('Request failed');
      err.status = res.status;
      throw err;
    };

    const postFormData = async (url) => {
      const formData = new FormData();
      formData.append('email', email);

      const res = await fetch(url, {
        method: 'POST',
        body: formData,
      });

      const contentType =
        res.headers && res.headers.get
          ? res.headers.get('content-type') || ''
          : '';

      if (contentType.includes('application/json')) {
        const result = await res.json();
        if (res.ok) return result;
        const message =
          (result && (result.message || result.msg)) || 'Request failed';
        const err = new Error(message);
        err.status = res.status;
        err.data = result;
        throw err;
      }

      if (res.ok) return { ok: true, status: res.status };

      const err = new Error('Request failed');
      err.status = res.status;
      throw err;
    };

    let lastError;
    for (const url of endpoints) {
      try {
        const result = await postJson(url);
        if (
          result &&
          typeof result.code !== 'undefined' &&
          result.code !== 200
        ) {
          throw new Error(result.message || result.msg || 'Request failed');
        }
        return result;
      } catch (e) {
        const status = e && typeof e.status === 'number' ? e.status : 0;
        if (status === 415) {
          try {
            const result = await postFormData(url);
            if (
              result &&
              typeof result.code !== 'undefined' &&
              result.code !== 200
            ) {
              throw new Error(result.message || result.msg || 'Request failed');
            }
            return result;
          } catch (e2) {
            lastError = e2;
            continue;
          }
        }
        lastError = e;
        continue;
      }
    }

    throw lastError || new Error('Request failed');
  },
};

export const afterSalesApi = {
  async selectAll() {
    const endpoints = ['/api/afterSales/selectAll', '/afterSales/selectAll'];

    const getJson = async (url) => {
      const res = await fetch(url, { method: 'GET' });
      const contentType =
        res.headers && res.headers.get
          ? res.headers.get('content-type') || ''
          : '';

      if (contentType.includes('application/json')) {
        const result = await res.json();
        if (res.ok) return result;
        const message =
          (result && (result.message || result.msg)) || 'Request failed';
        const err = new Error(message);
        err.status = res.status;
        err.data = result;
        throw err;
      }

      if (res.ok) return { ok: true, status: res.status };

      const err = new Error('Request failed');
      err.status = res.status;
      throw err;
    };

    try {
      return await getJson(endpoints[0]);
    } catch (e) {
      const status = e && typeof e.status === 'number' ? e.status : 0;
      if (status && status !== 404) throw e;
      if (!endpoints[1]) throw e;
      return await getJson(endpoints[1]);
    }
  },
};

export const softTableApi = {
  async selectAll() {
    const endpoints = ['/api/softTable/selectAll', '/softTable/selectAll'];

    const getJson = async (url) => {
      const res = await fetch(url, { method: 'GET' });
      const contentType =
        res.headers && res.headers.get
          ? res.headers.get('content-type') || ''
          : '';

      if (contentType.includes('application/json')) {
        const result = await res.json();
        if (res.ok) return result;
        const message =
          (result && (result.message || result.msg)) || 'Request failed';
        const err = new Error(message);
        err.status = res.status;
        err.data = result;
        throw err;
      }

      if (res.ok) return { ok: true, status: res.status };

      const err = new Error('Request failed');
      err.status = res.status;
      throw err;
    };

    try {
      return await getJson(endpoints[0]);
    } catch (e) {
      const status = e && typeof e.status === 'number' ? e.status : 0;
      if (status && status !== 404) throw e;
      if (!endpoints[1]) throw e;
      return await getJson(endpoints[1]);
    }
  },
};

export const seoTableApi = {
  async selectAll() {
    const endpoints = ['/api/seoTable/selectAll', '/seoTable/selectAll'];

    const getJson = async (url) => {
      const res = await fetch(url, { method: 'GET' });
      const contentType =
        res.headers && res.headers.get
          ? res.headers.get('content-type') || ''
          : '';

      if (contentType.includes('application/json')) {
        const result = await res.json();
        if (res.ok) return result;
        const message =
          (result && (result.message || result.msg)) || 'Request failed';
        const err = new Error(message);
        err.status = res.status;
        err.data = result;
        throw err;
      }

      if (res.ok) return { ok: true, status: res.status };

      const err = new Error('Request failed');
      err.status = res.status;
      throw err;
    };

    try {
      return await getJson(endpoints[0]);
    } catch (e) {
      const status = e && typeof e.status === 'number' ? e.status : 0;
      if (status && status !== 404) throw e;
      if (!endpoints[1]) throw e;
      return await getJson(endpoints[1]);
    }
  },
};

export const newsApi = {
  async selectAll() {
    const endpoints = ['/api/news/selectAll', '/news/selectAll'];

    const getJson = async (url) => {
      const res = await fetch(url, { method: 'GET' });
      const contentType =
        res.headers && res.headers.get
          ? res.headers.get('content-type') || ''
          : '';

      if (contentType.includes('application/json')) {
        const result = await res.json();
        if (res.ok) return result;
        const message =
          (result && (result.message || result.msg)) || 'Request failed';
        const err = new Error(message);
        err.status = res.status;
        err.data = result;
        throw err;
      }

      if (res.ok) return { ok: true, status: res.status };

      const err = new Error('Request failed');
      err.status = res.status;
      throw err;
    };

    try {
      return await getJson(endpoints[0]);
    } catch (e) {
      const status = e && typeof e.status === 'number' ? e.status : 0;
      if (status && status !== 404) throw e;
      if (!endpoints[1]) throw e;
      return await getJson(endpoints[1]);
    }
  },
};

export const difyChatApi = {
  async streamChatMessage({
    query,
    conversationId,
    user,
    inputs,
    files,
    onDelta,
    onMeta,
    onEnd,
    signal,
  }) {
    const baseUrl = 'https://dify.henghao-laser.cn/v1';
    const apiKey = process.env.VUE_APP_DIFY_API_KEY;
    if (!apiKey) {
      throw new Error('Missing Dify API key');
    }

    const res = await fetch(`${baseUrl}/chat-messages`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${apiKey}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        inputs: inputs || {},
        query: query || '',
        response_mode: 'streaming',
        conversation_id: conversationId || '',
        user: user || '',
        files: Array.isArray(files) ? files : [],
      }),
      signal,
    });

    if (!res.ok) {
      const contentType =
        res.headers && res.headers.get
          ? res.headers.get('content-type') || ''
          : '';
      if (contentType.includes('application/json')) {
        const data = await res.json();
        const message =
          (data && (data.message || data.msg)) || 'Request failed';
        const err = new Error(message);
        err.status = res.status;
        err.data = data;
        throw err;
      }
      const text = await res.text().catch(() => '');
      const err = new Error(text || 'Request failed');
      err.status = res.status;
      throw err;
    }

    if (!res.body || typeof res.body.getReader !== 'function') {
      throw new Error('Streaming not supported');
    }

    const reader = res.body.getReader();
    const decoder = new TextDecoder('utf-8');
    let buffer = '';
    let lastConversationId = conversationId || '';
    let ended = false;

    const emitMeta = (meta) => {
      if (typeof onMeta === 'function') onMeta(meta);
    };

    const emitDelta = (delta) => {
      if (!delta) return;
      if (typeof onDelta === 'function') onDelta(delta);
    };

    const emitEnd = (meta) => {
      if (ended) return;
      ended = true;
      if (typeof onEnd === 'function') onEnd(meta);
    };

    const handleData = (raw) => {
      const data = (raw || '').trim();
      if (!data) return;
      if (data === '[DONE]') {
        emitEnd({ conversationId: lastConversationId });
        return;
      }

      let obj;
      try {
        obj = JSON.parse(data);
      } catch (e) {
        return;
      }

      if (
        obj &&
        obj.conversation_id &&
        obj.conversation_id !== lastConversationId
      ) {
        lastConversationId = obj.conversation_id;
        emitMeta({ conversationId: lastConversationId });
      }

      const event = obj && obj.event ? String(obj.event) : '';
      if (event === 'message' || event === 'agent_message') {
        emitDelta(obj.answer || obj.delta || '');
        return;
      }

      if (event === 'error') {
        const err = new Error(
          (obj && (obj.message || obj.msg)) || 'Request failed',
        );
        err.data = obj;
        throw err;
      }

      if (event === 'message_end') {
        emitEnd({
          conversationId: lastConversationId,
          messageId: obj.message_id || '',
        });
      }
    };

    try {
      let reading = true;
      while (reading) {
        const { value, done } = await reader.read();
        if (done) {
          reading = false;
          break;
        }
        buffer += decoder.decode(value, { stream: true });
        const chunks = buffer.split(/\r?\n\r?\n/);
        buffer = chunks.pop() || '';
        for (const chunk of chunks) {
          if (!chunk) continue;
          const lines = chunk.split(/\r?\n/);
          const dataLines = [];
          for (const line of lines) {
            if (line.startsWith('data:')) {
              dataLines.push(line.slice(5).trimStart());
            }
          }
          if (!dataLines.length) continue;
          handleData(dataLines.join('\n'));
        }
      }
    } finally {
      try {
        reader.releaseLock();
      } catch (e) {
        void e;
      }
    }

    if (!ended && !(signal && signal.aborted)) {
      emitEnd({ conversationId: lastConversationId });
    }
    return { conversationId: lastConversationId };
  },
};
